import {Aurelia} from 'aurelia-framework'
import environment from './environment';
/*
import {PLATFORM} from 'aurelia-pal';
import {initialState} from "./aurelia/store/state";
import {Backend, TCustomAttribute} from 'aurelia-i18n';
*/


export function configure(aurelia: Aurelia) {
  aurelia.use
    .defaultBindingLanguage()
    .defaultResources()
    //.developmentLogging()
    .feature('aurelia');

    //.plugin(PLATFORM.moduleName('aurelia-http-client'))
    //.plugin('aurelia-store', { initialState })
    /*.plugin('aurelia-i18n', (instance) => {
      let aliases = ['t', 'i18n'];
      // add aliases for 't' attribute
      TCustomAttribute.configureAliases(aliases);

      // register backend plugin
      instance.i18next.use(Backend.with(aurelia.loader));

      // adapt options to your needs (see http://i18next.com/docs/options/)
      // make sure to return the promise of the setup method, in order to guarantee proper loading
      return instance.setup({
        attributes: aliases,
        whitelist: ['de', 'en'],
        preload: ['de', 'en'],
        lng: 'de',
        fallbackLng: 'de',
        debug: true,
        ns: ['translation', 'menu', 'product'],
        // defaultNS: 'translation',
        backend: {                                  // <-- configure backend settings
          loadPath: './locales/{{lng}}/{{ns}}.json', // <-- XHR settings for where to get the files from
        },
      });
    });*/

  //aurelia.use.developmentLogging(environment.debug ? 'debug' : 'warn');
  aurelia.start().then(() => aurelia.enhance());
}


